/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

import ExternalProviderContainer from '../../Auth/ExternalProvider/ExternalProviderContainer';
import { RETURN_URL_REGISTER } from '../../Auth/ExternalProvider/ReturnUrls';

import Layout from '../../Layout/Layout';
import SignUpForm from './SignUpForm';

import { useTranslator } from '@front-activerse/common-components';
import { currencySymbols } from '../const';

const SignUpContainer = ({
  register,
  redirectToPathAfterSuccess,
  action,
  loading,
  displayAppleButton,
  displayFacebookButton,
  displayGoogleButton,
  loginButtonURL,
  paymentMethods,
}) => {
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

  const { t } = useTranslator();

  const products = JSON.parse(localStorage.getItem('shoppingCartProducts'));

  const totalPrice = {
    amount: products.reduce((acc, product) => acc + product.price.amount, 0),
    currency: products[0].price.currency,
  };

  return (
    <Layout simpleLayout>
      <div className="page-template-auth full-height7">
        <Container className="py-xxl">
          <h1 className="text-center title-medium semi-bold mb-xl">{t('yourCart.title')}</h1>
          <Row>
            <Col xs={{ size: 12, order: 2 }} md={{ size: 6, order: 1 }}>
              <div className="page-container">
                <div className="auth-container">
                  <h1 className="text-center title-medium semi-bold mb-xl">{t('signUp.title')}</h1>
                  <ExternalProviderContainer
                    returnUrl={RETURN_URL_REGISTER}
                    action={action}
                    displayAppleButton={displayAppleButton}
                    displayFacebookButton={displayFacebookButton}
                    displayGoogleButton={displayGoogleButton}
                    isCheckboxChecked={isCheckboxChecked}
                  />
                  {(displayAppleButton || displayFacebookButton || displayGoogleButton) && (
                    <div className="line">
                      <span>{t('authorization.continueWithEmail.description')}</span>
                    </div>
                  )}
                  <SignUpForm
                    register={register}
                    loading={loading}
                    redirectToPathAfterSuccess={redirectToPathAfterSuccess}
                    action={action}
                    setIsCheckboxChecked={setIsCheckboxChecked}
                  />
                </div>
              </div>
              {loginButtonURL && (
                <p className="mt-xl text-center">
                  {t('authorization.alreadyHaveAnAccount')}{' '}
                  <Link to={loginButtonURL}>{t('authorization.logIn.button')}</Link>
                </p>
              )}
            </Col>
            <Col xs={{ size: 12, order: 1 }} md={{ size: 6, order: 2 }}>
              <div className="page-container">
                <div className="auth-container">
                  <h3 className="title-medium semi-bold mb-xl">
                    {t('paymentMethods.summary.title')}
                  </h3>
                  <div>
                    {products.map((product) => (
                      <div className="d-flex justify-content-between" key={product.id}>
                        <p
                          className="mb-0 pe-4"
                          dangerouslySetInnerHTML={{
                            __html: product.saleProductVariant.saleProduct.productCardTitle || '',
                          }}
                        />
                        <p className="mb-0 text-nowrap">
                          {product.price.amount} {currencySymbols[product.price.currency]}
                        </p>
                      </div>
                    ))}

                    <hr />
                    <div className="d-flex justify-content-between">
                      <h3 className="title-medium semi-bold mb-0">
                        {t('paymentMethods.summary.total.title')}
                      </h3>
                      <h3 className="title-medium semi-bold mb-0">
                        {totalPrice.amount + ' ' + currencySymbols[totalPrice.currency]}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-3 mb-xl">
                <p className="semi-bold mt-xl">{t('acceptedPaymentMethods.title')}</p>
                {paymentMethods?.map((paymentMethod) => (
                  <img
                    className="me-m mb-m"
                    src={paymentMethod.logoUrl}
                    alt={paymentMethod.name}
                    key={paymentMethod.id}
                  />
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

SignUpContainer.propTypes = {
  register: PropTypes.func.isRequired,
};

export default SignUpContainer;
